import React, { memo } from 'react'

import '../../../assets/styles/components/_forms.scss'

const Radio = memo(({ pillboxStyle, id, name, checked, disabled, label }) => {
  return (
    <div className={pillboxStyle ? 'radio-pillbox' : 'radio'}>
      <label htmlFor={id}>
        <input type='radio' id={id} name={name} defaultChecked={checked ? 'checked' : ''} disabled={disabled} />
        <span>
          {label}
        </span>
      </label>
    </div>
  )
})

export default Radio
